// extracted by mini-css-extract-plugin
export default {"DleRecordTypeDataSource":"DleRecordTypeDataSource_DleRecordTypeDataSource__G1euf"};